// src/components/PropertyPanel/CommonProperties/BorderRadiusControl.js
import React, { useState, useEffect } from 'react';
import { usePropertyPanel } from '../PropertyPanelContext';
import { extractValueAndUnit } from '../utils/styleUtils';
import { useSelector } from 'react-redux';
import { selectSelectedComponent } from '../../../redux/editorSlice';

const BorderRadiusControl = () => {
  const selectedComponent = useSelector(selectSelectedComponent);
  const { handleStyleChange } = usePropertyPanel();
  const style = selectedComponent?.style || {};
  
  // 테두리 둥글기 입력값 관리를 위한 로컬 상태
  const [borderRadiusInput, setBorderRadiusInput] = useState('');
  
  // 선택된 컴포넌트가 변경되면 둥글기 입력값 초기화
  useEffect(() => {
    if (style) {
      const { value, unit } = extractValueAndUnit(style.borderRadius || '0px');
      setBorderRadiusInput(`${value}${unit}`);
    }
  }, [style, selectedComponent?.id]);
  
  // 테두리 둥글기 변경 핸들러
  const handleBorderRadiusChange = (value) => {
    setBorderRadiusInput(value);
  };
  
  // 테두리 둥글기 적용 핸들러 (포커스를 잃을 때)
  const handleBorderRadiusBlur = () => {
    if (!selectedComponent) return;
    
    const { value, unit } = extractValueAndUnit(borderRadiusInput);
    handleStyleChange(selectedComponent, 'borderRadius', `${value}${unit}`);
  };
  
  return (
    <div className="property-group">
      <div className="property-group-title">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="3" y="3" width="18" height="18" rx="6" stroke="currentColor" strokeWidth="2" />
        </svg>
        테두리 둥글기
      </div>
      <div className="padding-controls">
        <div className="padding-control">
          <label style={{ minWidth: '30%' }}>둥글기</label>
          <input 
            type="text" 
            value={borderRadiusInput} 
            onChange={(e) => handleBorderRadiusChange(e.target.value)}
            onBlur={handleBorderRadiusBlur}
          />
        </div>
      </div>
    </div>
  );
};

export default BorderRadiusControl;